<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 22/9/2020
  -->

<template>
	<FormRow
        v-if="!readonly || valueData"
		v-bind="attrsNoListeners"
		:prop="prop"
		:title="title"
		:isVertical="isVertical"
        :class="readonly || noMargin ? '' : 'mb-3'"
		:showDividerTop="showDividerTop"
		:tooltipText="tooltipText"
		:tooltip-position="tooltipPosition">

		<div :class="{'input-background line-height-40': !readonly}" class="qw-row flex-nowrap">

			<div v-if="readonly"
				 style="line-height: 21px; padding-bottom: 10px">
				<div :class="{'borderDottedDiv': borderDotted}">
					{{dateFormatted}}
				</div>
			</div>

			<qw-date-picker
				v-else
				ref="datePickerRowItem"
				v-model="valueData"
				:class="[{pointer: !readonly, 'borderDotted': borderDotted, datePickerClass}]"
				:style="contentStyle"
				:type="type"
				:readonly="readonly"
				:disabled="disabled"
				:placeholder="placeholder"
				:default-value="defaultValue"
				:hideInputBackground="true"
				:pickerOptions="pickerOptions"
				:disablePastDates="disablePastDates"
				:disableFutureDates="disableFutureDates"
				:disabledDate="disabledDate"
				:pickAsUTCDate="pickAsUTCDate"
				:initialView="initialView"
				@change="notifyValueChanged()"
				:format="format">
			</qw-date-picker>
			<i v-if="!readonly && !isDateTimePicker" class="fontello icon-angle-down clickable" @click="openPicker()"></i>
		</div>

	</FormRow>

</template>

<script>
import BaseFormRow from "@/core/components/Form/Base/BaseFormRow.vue"
import FormRow from "@/core/components/Form/Base/FormRow.vue";
import moment from "moment"
import dayjs from "dayjs";

export default {
	name: "FormDateRow",
	components: {FormRow},
	extends: BaseFormRow,
	props: {
		readonly: {Boolean, default: false},
		disabled: {Boolean, default: false},
		isVertical: Boolean,
		format: {String, default: "MMM DD, YYYY"},
		valueFormat: String,
		placeholder: String,
		disablePastDates: Boolean,
		disableFutureDates: Boolean,
		disabledDate: Function,
		type: {String, default: 'date'},
		initialView: {String, default: 'date'},
		noMargin: Boolean,
        readOnly: Boolean,
		borderDotted: Boolean,
		datePickerClass: String,
		pickAsUTCDate: Boolean,
		pickerOptions: {Object, default: () => ({})},
		defaultValue: {Object, default: () => new Date()},
		contentStyle: {Object, default: () => ({'flex-grow': 1})},
	},

	inheritAttrs: false,

	data() {
		return {
		}
	},

	methods: {

		async onDatePickerFocus(){
			this.clearFormValidation()
			await this.$nextTickPromise()
			let elements = document.querySelectorAll('[aria-hidden="false"] .el-date-picker__header-label')
			console.log("onDatePickerFocus: document.getElementsByClassName(\"el-date-picker__header-label\") = ", elements)
			// console.log("this.$refs.datePickerRowItem = ", this.$refs.datePickerRowItem.getDatePicker())
			if(this.initialView === "year"){
				elements[0].click()
				// this.$refs.datePickerRowItem.getDatePicker().picker.showYearPicker()// = "year"
			} else if(this.initialView === "month"){
				elements[1].click()
				// this.$refs.datePickerRowItem.getDatePicker().picker.showMonthPicker()
			}
		},

		openPicker() {
			this.$refs.datePickerRowItem.focus()
		},
		formatDataIn(data) {
			return data ? data : null
			// if(!data){
			// 	return null
			// }
			// // let res =  moment(data).format(this.format)
			// // console.log("formatDataIn: res = ", res, ", data = ", data)
			// return new Date(data)
		},
		//
		formatDataOut(data) {
			if (data && data.getTime && this.type !== 'datetime') {
				data = moment(data).endOf('day').valueOf()
			}
			data = data || 0
			// let res = moment(data, this.valueFormat).valueOf()
			console.log("formatDataOut: data = ", data)
			return data
		},



	},

	computed: {
        dateFormatted(){
            return dayjs(this.valueData).format(this.format.toUpperCase())
        },


		isDateTimePicker() {
			return this.type === "datetime";
		},
	},
}
</script>

<style>
.bold2 {
	font-weight: 600;
}

</style>
